import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { TenantContext } from "@nens/ranalib";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdatePublicationCommentListQuery } from "@/queries/query-publication-comment";

export const useResolveComment = (publicationId: string) => {
  const update = useUpdatePublicationCommentListQuery(publicationId);
  const { user, isPublic } = useContext(TenantContext);
  return useMutationWithErrorHandler(
    async ({ commentId, type }: { commentId: string; type: "resolve" | "unresolve" }) => {
      const comment = await getRanaApiV1().PublicationCommentsApi[
        type === "resolve" ? "commentResolve" : "commentUnresolve"
      ]({
        publicationId,
        commentId,
        // User info only needed when in a shared publication.
        commentEventCreate: { creator: isPublic ? user : null },
      });

      await update(commentId, comment);
    }
  );
};
